import React, { useState } from "react";

import { useHistory } from "react-router-dom";
import { useIsDispatcher } from "../../../hooks";
import {
  ALL_EMPLOYEES_QUERY,
  EMPLOYEE_PAGINATION_QUERY
} from "../../../graphql/Employees/Employees.graphql";

import EmployeeFilters from "./EmployeeFilters";
import DataTable from "../../../components/DataTable";

import { EMPLOYEE_COLUMNS, DRIVER_COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import { getFilterState, saveFilterState } from "../../../utils";

const EmployeesPage = () => {
  const history = useHistory();

  const INITIAL_FILTER_STATE = getFilterState("EMPLOYEE_FILTERS", {
    Active: true
  });
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const isDispatcher = useIsDispatcher();

  const handleSetFilters = inputs => {
    saveFilterState("EMPLOYEE_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => handleSetFilters({ Active: true });

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={EmployeeFilters}
        columns={EMPLOYEE_COLUMNS}
        filters={filters}
        name="Employees"
        orderByMulti={["LastName_ASC", "FirstName_ASC"]}
        query={ALL_EMPLOYEES_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Employees"
        onAddClick={() => history.push("/hr/employees/new")}
      />
      <DataTable
        columns={isDispatcher ? DRIVER_COLUMNS : EMPLOYEE_COLUMNS}
        dataQuery={ALL_EMPLOYEES_QUERY}
        initialSortBy={[
          { id: "LastName", desc: false },
          { id: "FirstName", desc: false }
        ]}
        name="Employee"
        paginationQuery={EMPLOYEE_PAGINATION_QUERY}
        where={isDispatcher ? { Active: true, DriverFlag: true } : filters}
        onRowClick={({ RecId }) => {
          history.push(`/hr/employees/${RecId}/personal`);
        }}
      />
    </React.Fragment>
  );
};
EmployeesPage.propTypes = {};
export default EmployeesPage;
